import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import styled from "styled-components";

export const useStyles = makeStyles<Theme>({
	inputText: () => ({
		"& .MuiFilledInput-underline:before": {
			borderBottom: "1px solid #0000006b !important",
		},
		"& .MuiInputBase-input": {
			background: "field",
		},
	}),
	inputAutocomplete: () => ({
		"& .MuiInputBase-root": {
			paddingTop: "0px !important",
		},
	}),
});

export const Container = styled.div`
	padding: 0 0 2rem;

	> h2 {
		font-weight: bold;
	}
`;

export const ContainerTreeView = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex-direction: column;
		align-items: start;
	}
`;

export const ContentTreeViewItem = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 6px 0;

	#hierarchy-item-custom-level {
		max-width: 200px;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		width: 100%;

		#hierarchy-item-custom-level,
		#hierarchy-item-custom-email {
			max-width: 150px;
		}
	}
`;

export const ContentTreeViewCard = styled.div`
	background-color: #fff;
	min-height: 600px;
`;

export const ContentTreeViewCardTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	padding: 0.5rem 1rem;
	border-bottom: 1px solid #ddd;
`;

export const ContentTreeViewCardContent = styled.div`
	padding: 0.5rem 1rem;
`;

export const ContainerErrorMessages = styled.div`
	margin-bottom: 10px;
	display: flex;
	flex-direction: column;
	gap: 10px;
`;
